<template>
  <div class="container-fluid">
    <b-row class="admin-page">
      <div class="col-md-8">
        <b-form class="admin-form" @submit.stop.prevent="submitJotform">
          <b-form-group horizontal label="Name">
            <b-form-input type="text" v-model="jotform.name"></b-form-input>
          </b-form-group>
          <b-form-group horizontal label="Form Id">
            <b-form-input type="text" v-model="jotform.form_id"></b-form-input>
          </b-form-group>
          <b-form-group horizontal label="Mailbox">
            <b-form-select v-model="jotform.mailbox_id" :options="mailboxes"></b-form-select>
          </b-form-group>
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="warning" @click="resetJotform(jotform.id)">Reset</b-button>
          <b-button type="delete" variant="danger" v-if="jotform.hasOwnProperty('id')" @click="deleteJotform(jotform.id)">Delete</b-button>
        </b-form>
      </div>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {jotformMixins} from '@/mixins/jotformMixins'
export default {
  name: 'Jotform',
  props: ['jotform', 'jotforms'],
  mixins: [jotformMixins],
  data () {
    return {
      mailboxes: []
    }
  },
  created () {
    this.getMailboxes()
  },
  updated () {

  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  methods: {
    getMailboxes () {
      this.$http.get('/mailboxes')
        .then(response => this.setMailboxes(response))
        .catch((e) => this.error(e))
    },
    setMailboxes (response) {
      this.mailboxes = response.data.map(function (mailbox) {
        return {text: mailbox.name, value: mailbox.id}
      })
    },
    submitJotform () {
      var jotformObject = this.jotform
      if (jotformObject.hasOwnProperty('id')) {
        this.$http.put(('/jotforms/' + jotformObject.id), {jotform: jotformObject})
          .then(response => this.submitSuccessful(response))
          .catch((e) => this.error(e))
      } else {
        this.$http.post('/jotforms', {jotform: jotformObject})
          .then(response => this.submitSuccessful(response))
          .catch((e) => this.error(e))
      }
    },
    deleteJotform (id) {
      this.$http.delete('/jotforms/' + id)
        .then(response => this.deleteSuccessful(response))
        .catch((e) => this.error(e))
    },
    submitSuccessful (response) {
      this.$emit('submit-successful')
    },
    deleteSuccessful (response) {
      this.$emit('delete-successful')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/jotforms/Show.vue